import { createReducer, on } from '@ngrx/store';
import { lockPlatform, lockService, unlockPlatform, unlockService } from '@stores/lock/lock.actions';

export const lockFeatureKey = 'lock';

export type LockState = {
  platformLocked: boolean;
  serviceLocked: boolean;
  userId: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
};

const initialState: LockState = {
  platformLocked: false,
  serviceLocked: false,
  userId: undefined,
  firstName: undefined,
  lastName: undefined,
};

export const lockReducer = createReducer(
  initialState,
  on(lockPlatform, (state, { userId, firstName, lastName, overwriteLock }) => {
    return {
      ...state,
      platformLocked: !overwriteLock,
      userId,
      firstName,
      lastName,
    };
  }),
  on(unlockPlatform, (state, { userId }) => ({
    ...state,
    platformLocked: false,
    userId: userId,
  })),
  on(lockService, (state, { userId, overwriteLock }) => {
    return {
      ...state,
      serviceLocked: !overwriteLock,
      userId: userId,
    };
  }),
  on(unlockService, (state, { userId }) => ({
    ...state,
    serviceLocked: false,
    userId: userId,
  }))
);
